import React from 'react';
import { Link as RouterLink, useLocation, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Avatar, AppBar, Toolbar, Typography, Box, Link } from '@mui/material';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import logo from '../../assets/images/logo.png';
import headerBg from '../../assets/images/header-bg.png';
import { routes } from '../../routes';
import useDocumentTitle from '../../hooks/use-document-title';
import { useFeatureFlags } from '../../hooks/use-feature-flags';
import { selectors as alertSelectors } from '../../store/dux/alerts-dux';
import { SubHeader } from './SubHeader';
import { useCurrentUser } from '../../hooks/use-current-user';

function Header() {
  const { isAuthenticated, username } = useCurrentUser();
  const location = useLocation();
  const featureFlags = useFeatureFlags();
  const banner = useSelector(alertSelectors.banner);

  const module = routes.find((route) => matchPath(route, location.pathname));

  const moduleName =
    typeof module?.name === 'function'
      ? module.name(featureFlags)
      : module?.name;

  useDocumentTitle(moduleName);

  // Hide standard header for Signal mobile module
  if (location.pathname.startsWith('/signal')) {
    return null;
  }

  return (
    <AppBar position="static" data-testid="standard-header">
      <Toolbar
        variant="dense"
        sx={{ backgroundColor: '#333', backgroundImage: `url(${headerBg})` }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link
              component={RouterLink}
              to="/"
              sx={{
                flexGrow: 1,
                height: 29,
                display: { xs: 'none', sm: 'block' },
                marginLeft: 2,
                marginRight: 2,
              }}
            >
              <img
                style={{ height: '29px' }}
                src={logo}
                alt="Advanced Agrilytics"
              />
            </Link>
            {module && <Typography variant="body1">{moduleName}</Typography>}
          </Box>
          {isAuthenticated && (
            <Typography variant="body1">Hello, {username}</Typography>
          )}
        </Box>
      </Toolbar>
      <SubHeader component={module?.subHeaderComponent} />
      {banner?.message && (
        <Toolbar
          variant="dense"
          sx={{
            backgroundColor: '#B00020',
            paddingLeft: 5,
            textTransform: 'uppercase',

            '& .MuiAvatar-root': {
              backgroundColor: '#FFFFFF',
              color: '#B00020',
              marginRight: 1,
              height: '32px',
              width: '32px',
            },
          }}
        >
          <Avatar>
            <NotificationImportantIcon />
          </Avatar>
          <Typography variant="body1">{banner.message}</Typography>
        </Toolbar>
      )}
    </AppBar>
  );
}

export default Header;
